export const DOMAIN_CALL_DATA = 'DOMAIN/CALL_DATA';
export const DOMAIN_INITIAL_CALL_DATA = 'DOMAIN/INITIAL_CALL_DATA';
export const DOMAIN_ASR_ERROR_DATA = 'DOMAIN/ASR_ERROR_DATA';
export const DOMAIN_CALL_STARTED = 'DOMAIN/CALL_STARTED';
export const DOMAIN_CALL_ENDED = 'DOMAIN/CALL_ENDED';
export const DOMAIN_DAEMON_VERSION = 'DOMAIN/DAEMON_VERSION';
